import * as yup from 'yup'

export const validateCreateUsers = yup.object().shape({
    first_name: yup
    .string()
    .required('Campo requerido.')
    .min(4, 'El NOMBRE debe tener más de 3 caracteres'),
    last_name: yup
    .string()
    .required('Campo requerido.')
    .min(4, 'El APELLIDO debe tener más de 3 caracteres'),
    dni: yup
    .string()
    .required('Campo requerido.')
    .min(4, 'La cédula debe tener más de 3 caracteres numéricos'),
    phone: yup
    .string()
    .required('Campo requerido.')
    .min(4, 'El TELÉFONO debe tener más de 3 caracteres numéricos'),
    email: yup
    .string()
    .required('Campo requerido.')
    .email('Introduzca un correo electrónico válido.'),
    password: yup
    .string()
    .required('Campo requerido.')
    .min(6, 'Debe introducir una contraseña de al menos 6 caracteres.'),
    role: yup
    .string()
    .required('Campo requerido.')
    .oneOf(['user', 'admin', 'seller', 'domiciliary', 'integration'], 'Debes elegir entre estas opciones'),
    store_id: yup.mixed().when('role', {
        is: 'domiciliary',
        then: (schema) =>
            schema
                .required('Seleccione la sede asignada.')
                .test(
                    'store-required',
                    'Seleccione la sede asignada.',
                    (v) => v !== undefined && v !== null && v !== '',
                ),
        otherwise: (schema) => schema.nullable(),
    }),
    status: yup
    .string()
    .required('Campo requerido.')
    .oneOf(['active', 'inactive', 'pending security verification', 'pending user data', 'pending validation'], 'Debes elegir entre estas opciones'),
    allowed_modules: yup.array().of(yup.string()).nullable().notRequired(),
})

